import { forwardRef, useState } from "@wordpress/element";
import { Modal } from "@mui/base/Modal";

export function Share() {
	const [open, setOpen] = useState(false);
	const toggle = () => setOpen((open) => !open);

	const [copied, setCopied] = useState(false);

	const url = window.location.href;

	async function copy() {
		await navigator.clipboard.writeText(url);
		setCopied(true);
		setTimeout(() => setCopied(false), 1000);
	}

	return (
		<>
			<button
				onClick={toggle}
				className="wp-block-steam-blocks-offer-button-share__trigger"
			>
				<span>Udostępnij link</span>

				<svg
					width={24}
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M15.75 8H17.625C18.1223 8 18.5992 8.19754 18.9508 8.54917C19.3025 8.90081 19.5 9.37772 19.5 9.875V18.875C19.5 19.3723 19.3025 19.8492 18.9508 20.2008C18.5992 20.5525 18.1223 20.75 17.625 20.75H6.375C5.87772 20.75 5.40081 20.5525 5.04917 20.2008C4.69754 19.8492 4.5 19.3723 4.5 18.875V9.875C4.5 9.37772 4.69754 8.90081 5.04917 8.54917C5.40081 8.19754 5.87772 8 6.375 8H8.25M15.75 5L12 1.25M12 1.25L8.25 5M12 1.25V14.0469"
						stroke="black"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</button>

			<Modal
				open={open}
				onClose={toggle}
				slots={{ backdrop: Backdrop }}
				className="wp-block-steam-blocks-offer-button-share__modal"
			>
				<div className="wp-block-steam-blocks-offer-button-share__content">
					<div className="wp-block-steam-blocks-offer-button-share__lead">
						<span className="has-subtitle-font-size">Udostępnij ofertę</span>

						<button
							onClick={() => setOpen(false)}
							className="wp-block-steam-blocks-offer-button-share__close"
						>
							<svg
								width={24}
								viewBox="0 0 24 24"
								fill="currentColor"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path d="M8.4 17.5004L7 16.1004L10.6 12.5004L7 8.92539L8.4 7.52539L12 11.1254L15.575 7.52539L16.975 8.92539L13.375 12.5004L16.975 16.1004L15.575 17.5004L12 13.9004L8.4 17.5004Z" />
							</svg>
						</button>
					</div>

					<div className="wp-block-steam-blocks-offer-button-share__description">
						Chcesz przesłać komuś tę ofertę? Skopiuj link i udostępnij go w
						preferowany przez siebie sposób.
					</div>

					<div className="wp-block-steam-blocks-offer-button-share__url">
						<span>{url}</span>

						<button onClick={copy}>
							{copied ? "Skopiowano" : "Kopiuj link"}
						</button>
					</div>
				</div>
			</Modal>
		</>
	);
}

const Backdrop = forwardRef((props, ref) => {
	const { open, className, ownerState, ...other } = props;

	return (
		<div
			ref={ref}
			{...other}
			className="wp-block-steam-blocks-offer-button-share__backdrop"
		/>
	);
});
